import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ScoutAndChoosePage from "./LesQuisScoutBeta";

export default function ScoutFixedLakePage() {
  const startFlow = new URLSearchParams(window.location.search).get("start_flow") === "1";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <div className="catchcompass-fixed-lake-scout">
      <style>{`
        .catchcompass-fixed-lake-scout section:first-of-type > label:first-child,
        .catchcompass-fixed-lake-scout section:first-of-type > select,
        .catchcompass-fixed-lake-scout section:first-of-type > select + button {
          display: none !important;
        }
      `}</style>

      <div className="mx-auto w-full max-w-3xl px-3 pt-3 sm:px-6">
        {startFlow ? (
          <>
            <div className="flex items-center justify-between gap-3">
              <p className="text-xs font-medium text-secondary">Step 2 of 3 · Find a peg</p>
              <Link to="/scout" className="text-xs font-semibold text-accent">
                Change water
              </Link>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-between gap-3 rounded-lg border border-border bg-inset px-3 py-2 text-xs text-secondary">
            <span>Water already selected in Start Fishing</span>
            <Link to="/scout" className="font-semibold text-accent">
              Change water
            </Link>
          </div>
        )}
      </div>

      <ScoutAndChoosePage />
    </div>
  );
}
